export class MoleculePanelEditRowTableBackupsAutoComponent {
    public templateUrl = require('./backups-auto.html?external');
}
